import React, { useState, memo } from 'react';
import TextField from '@material-ui/core/TextField';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { addNewWatchlistCategory } from '../watchlistApiCalls';
import { useDispatch } from 'react-redux';

const CreateNewWatchlistCategory = ({ onCreateNewCategory = () => {} }) => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const [isInputFeild, setIsInputFeild] = useState(false);
  const [loading, setLoading] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState('');

  const addNewCategoryHandler = async () => {
    setLoading(true);
    const { isSuccess, addedCategory } = await dispatch(addNewWatchlistCategory({ name: newCategoryName }));
    onCreateNewCategory({ category: addedCategory, tab: 0 });
    setLoading(false);
    if (isSuccess) setNewCategoryName('');
  };

  return isInputFeild ? (
    <Grid container alignItems="center" justify="flex-start" spacing={2} className={classes.inputSection}>
      <Grid item xs={12} md={7}>
        <TextField
          className={classes.newWatchlistInputFeild}
          size={'small'}
          label="Enter new watchlist label"
          value={newCategoryName}
          variant="outlined"
          inputProps={{ maxLength: 50 }}
          onChange={event => {
            setNewCategoryName(event.target.value.trimStart());
          }}
        />
      </Grid>
      <Grid container item xs={12} md={5} alignItems="center" justify="flex-end">
        <Button
          size="small"
          startIcon={<AddCircleOutlineIcon />}
          color="primary"
          variant="contained"
          disabled={!newCategoryName || loading}
          onClick={addNewCategoryHandler}>
          {loading ? 'Adding...' : 'Add'}
        </Button>
        <Button
          size="small"
          className={classes.cancelAddingNewWatchlist}
          color="primary"
          variant="contained"
          onClick={() => setIsInputFeild(false)}>
          Close
        </Button>
      </Grid>
    </Grid>
  ) : (
    <div className={classes.addNewWatchlistSection} onClick={() => setIsInputFeild(true)}>
      <AddCircleOutlineIcon color="primary" />
      <span className={classes.addNewWatchlistBtnText}>Create new watchlist</span>
    </div>
  );
};

export default memo(CreateNewWatchlistCategory);

const useStyle = makeStyles(theme => ({
  inputSection: {
    paddingTop: '12px',
  },
  addNewWatchlistSection: {
    cursor: 'pointer',
    width: 'fit-content',
    paddingTop: '12px',
  },
  newWatchlistInputFeild: {
    width: '100%',
  },
  cancelAddingNewWatchlist: {
    marginLeft: '10px',
  },
  addNewWatchlistBtnText: {
    color: theme.palette.primary.main,
    paddingLeft: '7px',
    fontSize: '15px',
    paddingTop: '13px',
  },
}));
